<section class = "agpr-distributionDashboard">
    <h2 class="u-srOnly">{{ 'Discover.pageHeader.distributionDashboard' | localize }}</h2>
    <agpr-scroll-panel>
        <div class="agpr-distributionDashboard-center">
            <agpr-panel
                *ngIf="quotaInfo"
                header="Discover.distributionDashboard.usageInformation"
                [toggleable]="false"
                [headingLevel]="3"
                [noBorder]="true"
            >
            <div class="agpr-distributionDashboard-chart">
                <agpr-distribution-usage-chart
                    [totalUsagePercentage]="totalUsagePercentage"
                    [accountInfo]="currentAccount"
                    [resetDate]="resetDate"
                    [quotaInfo]="quotaInfo"
                    [quotaOverTime]="quotaOverTime"
                    (openBuyQuotaDialog)="openBuyQuotaDialog()"
                ></agpr-distribution-usage-chart>
            </div>
            </agpr-panel>
            <div class="agpr-distributionDashboard-quotaOverTimeChart">
                <label>{{'Discover.distributionDashboard.chart.recipientsOverTime' | localize}}</label>
                <agpr-message
                    *ngIf="noRecipientsUsed"
                    class="agpr-distributionDashboard-quotaOverTimeChart-noContentMessage"
                    [severity]="messageSeverities.noContent"
                >
                    {{ 'Discover.distributionDashboard.chart.recipientsOverTime.noRecipientsUsed' | localize }}
                </agpr-message>
                <agpr-chart
                    [chart]="quotaOverTimeChart"
                ></agpr-chart>
            </div>
            <div class="agpr-distributionDashboard-accountStatistics">
                <agpr-panel
                    *ngIf="quotaInfo"
                    header="Discover.distributionDashboard.accountStatistics"
                    [toggleable]="false"
                    [headingLevel]="3"
                    [noBorder]="true"
                >
                    <div class="agpr-distributionDashboard-accountStatistics-heading">
                        <div class="agpr-distributionDashboard-accountStatistics-dateRangeSelector">
                            <label>
                                {{ 'Discover.distributionDashboard.accountStatistics.dataRange' | localize }}
                            </label>
                            <agpr-date-query-popup
                                id="monitoringSearchDatequery"
                                class="agpr-monitoringSearch-dateQueryInput"
                                [(ngModel)]="dateFilterSelected"
                                [options]="distributionDateQueryInputTopicOptions"
                                [hideDateTypeSelection]="true"
                                (ngModelChange)="calculateAccountStats()"
                            >
                            </agpr-date-query-popup>
                        </div>

                        <div class="agpr-distributionDashboard-accountStatistics-mppAdjustedEstimates">
                            <agpr-checkbox
                                id="distributions_dashboard_enableMppEstimates"
                                label="Discover.distribution.statistics.mppAdjustedEstimates"
                                [binary]="true"
                                [(ngModel)]="enableMppEstimates"
                                (ngModelChange)="changeEmphasizeFields()"
                            >
                                <a
                                    agprTooltip="Discover.distribution.statistics.mppAdjustedEstimates.info"
                                    [escape]="false"
                                    role="img"
                                    class="fa-regular fa-circle-info agpr-distributionDashboard-accountStatistics-mppAdjustedEstimates-tooltip"
                                    [interactiveTooltip]="true"
                                    href="https://help.agilitypr.com/en/articles/6816484-agility-email-reporting-with-apple-mail-privacy-protection"
                                    target="_blank"
                                ></a>
                            </agpr-checkbox>
                        </div>

                    </div>
                    <div
                        [agprLoading]="accountStatisticsLoading"
                        [overlayStyleClass]="'agpr-distributionDashboard-chartLoading'"
                        [loadingIndicatorStyleClass]="'agpr-distributionDashboard-chartLoadingIndicator'"
                        class="agpr-distributionDashboard-accountStatistics-recipientEngagement"
                    >
                        <div class="agpr-distributionDashboard-statistics">
                            <div class="agpr-distributionDashboard-statistics-column">
                                <span
                                    role="img"
                                    class="fa-regular fa-circle-info agpr-distributionDashboard-statistics-infoCircle"
                                    [escape]="false"
                                    [agprTooltip]="sentStatistic.hover"
                                ></span>
                                <span class="agpr-distributionDashboard-statistics-header">
                                    {{ sentStatistic.header | localize }}
                                </span>
                                <div class="agpr-distributionDashboard-statistics-container">
                                    <div class="agpr-distributionDashboard-statistics-label-container">
                                        <span class="agpr-distributionDashboard-statistics-label">
                                            {{ sentStatistic.distributionsLabel | localize }}
                                        </span>
                                        <span class="agpr-distributionDashboard-statistics-label-number">
                                            {{ sentStatistic.distributions}}
                                        </span>
                                    </div>
                                    <div class="agpr-distributionDashboard-statistics-label-container">
                                        <span class="agpr-distributionDashboard-statistics-label">
                                            {{ sentStatistic.recipientsLabel | localize }}
                                        </span>
                                        <span class="agpr-distributionDashboard-statistics-label-number">
                                            {{ sentStatistic.recipients}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div
                                *ngFor="let key of statisticsKeys"
                                class="agpr-distributionDashboard-statistics-column"
                                [ngClass]="{'agpr-distributionDashboard-statistics-column-expanded' : statistics[key].expanded}"
                            >
                                <span
                                    role="img"
                                    class="fa-regular fa-circle-info agpr-distributionDashboard-statistics-infoCircle"
                                    [escape]="false"
                                    [agprTooltip]="statistics[key].hover"
                                ></span>
                                <span class="agpr-distributionDashboard-statistics-header">
                                    {{ statistics[key].header | localize }}
                                </span>
                                <div class="agpr-distributionDashboard-statistics-container">
                                    <div class="agpr-distributionDashboard-statistics-chart-container">
                                        <agpr-chart
                                            class="agpr-distributionDashboard-statistics-chart"
                                            [chart]="statistics[key].chart"
                                        >
                                        </agpr-chart>
                                        <span
                                            *ngIf="statistics[key].canExpand && enableMppEstimates"
                                            class="agpr-distributionDashboard-statistics-estimated"
                                        >
                                            {{'Discover.distribution.statistics.estimated' | localize }}
                                        </span>
                                    </div>
                                    <div class="agpr-distributionDashboard-statistics-label-container">
                                        <span class="agpr-distributionDashboard-statistics-label">
                                            {{ statistics[key].label | localize }}
                                        </span>
                                        <span class="agpr-distributionDashboard-statistics-label-number">
                                            {{ statistics[key].count }}
                                        </span>
                                        <span
                                            *ngIf="statistics[key].canExpand && enableMppEstimates"
                                            class="agpr-distributionDashboard-statistics-estimated"
                                        >
                                            {{'Discover.distribution.statistics.estimated' | localize }}
                                        </span>
                                    </div>
                                </div>
                                <agpr-panel
                                    *ngIf="statistics[key].canExpand"
                                    class="agpr-distributionDashboard-statistics-expandSection"
                                    (collapsedChange)="toggleExpand(statistics[key])"
                                    [canOnlyClickIcon]="true"
                                    [collapsed]="!statistics[key].expanded"
                                    [toggleArrowTooltip]="!statistics[key].expanded ? 'Discover.distribution.statistics.moreDetails' : 'Discover.distribution.statistics.lessDetails'"
                                >

                                    <div
                                        *ngFor="let additionalStatistic of statistics[key].additionalStatistics"
                                        class="agpr-distributionDashboard-statistics-expandSection-row"
                                        [ngClass]="{'agpr-distributionDashboard-statistics-expandSection-row-emphasize': additionalStatistic.emphasize}"
                                    >
                                        <div>
                                            <span class="agpr-distributionDashboard-statistics-expandSection-label">
                                                {{additionalStatistic.label | localize }}
                                            </span>
                                            <span
                                                role="img"
                                                class="fa-regular fa-circle-info agpr-distributionDashboard-statistics-expandSection-info"
                                                [escape]="false"
                                                [agprTooltip]="additionalStatistic.info"
                                            ></span>
                                        </div>
                                        <span class="agpr-distributionDashboard-statistics-expandSection-count">
                                            {{additionalStatistic.count}}
                                        </span>
                                    </div>
                                </agpr-panel>
                                <span
                                    *ngIf="!!statistics[key].warning"
                                    class="fa-solid fa-circle-exclamation agpr-distributionDashboard-statistics-warningCircle"
                                    [ngClass]="{'agpr-distributionDashboard-statistics-warningCircle-expanded' : statistics[key].canExpand}"
                                ></span>
                            </div>
                        </div>
                        <div class="agpr-distributionDashboard-statistics-errors">
                            <agpr-message *ngIf="!!bounceStatistic.warning" [severity]="messageSeverities.warning">
                                <span [innerHTML]="'Discover.distributionDashboard.statistics.bounceRate.warning' | localize"></span>
                            </agpr-message>
                            <agpr-message *ngIf="!!spamStatistic.warning" [severity]="messageSeverities.warning">
                                <span [innerHTML]="'Discover.distributionDashboard.statistics.spamReportRate.warning' | localize"></span>
                            </agpr-message>
                            <agpr-message *ngIf="!!unsubscribeStatistic.warning" [severity]="messageSeverities.warning">
                                <span [innerHTML]="'Discover.distributionDashboard.statistics.unsubscribeRate.warning' | localize"></span>
                            </agpr-message>
                        </div>
                    </div>
                </agpr-panel>
            </div>
        </div>
    </agpr-scroll-panel>
</section>
